var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAskCobaltSparkle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 .667c.306 0 .572.208.646.505l.868 3.47c.181.723.242.932.345 1.094.104.162.242.3.405.404.161.104.371.164 1.093.345l3.471.868a.667.667 0 0 1 0 1.293l-3.47.868c-.723.18-.933.242-1.095.345-.162.104-.3.242-.404.404-.103.162-.164.372-.345 1.094l-.868 3.47a.666.666 0 0 1-1.293 0l-.867-3.47c-.18-.722-.242-.932-.346-1.094a1.335 1.335 0 0 0-.404-.404c-.162-.103-.371-.164-1.094-.345l-3.47-.868a.666.666 0 0 1 0-1.293l3.47-.868c.723-.18.932-.241 1.094-.345.163-.104.3-.242.404-.404.104-.162.166-.371.346-1.094l.867-3.47.037-.108A.666.666 0 0 1 8 .667Z"
})));
SvgAskCobaltSparkle.displayName = "SvgAskCobaltSparkle";
export { SvgAskCobaltSparkle as ReactComponent };
export default SvgAskCobaltSparkle;